import { render, staticRenderFns } from "./WebshopAccess.vue?vue&type=template&id=000a8c4c&"
import script from "./WebshopAccess.vue?vue&type=script&lang=js&"
export * from "./WebshopAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports